var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container",on:{"click":_vm.handleClick}},[_c('img',{style:(_vm.logoStyle),attrs:{"src":require("@/assets/logos/eaglemask.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }